import React, { PureComponent } from 'react';
import { Translate } from 'react-redux-i18n';
import authProvider from '../../../../core/AuthenticationProvider';

class LoginButton extends PureComponent {
  onClick = () => {
    authProvider.signin();
  };

  render() {
    return (
      <div onClick={this.onClick} className="login-button">
        <img src="/images/login_icon.svg" />
        <Translate value="common.login" />
      </div>
    );
  }
}

LoginButton.propTypes = {};

export default LoginButton;
